<template>
  <div class="container">
    <ald-text>{{ $t('message.generic.error.notFound2') }}</ald-text>
    <Links />
  </div>
</template>

<script>
import Links from '../../main/Links';

export default {
  components: {
    Links
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding-top: 20px;
  padding-bottom: 20px;
}
</style>
